import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { injectInstallMetadata } from '@/lib/install-metadata'
import '@fontsource-variable/ibm-plex-sans'
import '@fontsource/ibm-plex-mono/400.css'
import '@fontsource/ibm-plex-mono/500.css'
import './index.css'

injectInstallMetadata()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
